import { useRef } from 'react';
import { Trans } from '@lingui/react';
import GoogleRatingsReviews from '../GoogleRatings/GoogleReviews';
import { useTrackElementView } from '../../../hooks/useTrackElementView';
import { useAppConfiguration } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadGoogleReviews = () => {
  const googleReviewsSectionRef = useRef(null);
  const {
    trackLandingPageType
  } = useAppConfiguration();
  useTrackElementView(googleReviewsSectionRef, {
    category: 'Google Reviews',
    action: 'View',
    label: 'Google Reviews Section Visible'
  }, trackLandingPageType);
  return /*#__PURE__*/_jsx("div", {
    className: "box gap white",
    ref: googleReviewsSectionRef,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "google-reviews-section",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "google-reviews-section__headline",
          children: /*#__PURE__*/_jsx(Trans, {
            id: "carlead.happyCustomersSlim.title",
            message: "Sold! Our Happy Customers nation Wide",
            components: [/*#__PURE__*/_jsx("br", {
              className: "d-none d-md-block"
            })]
          })
        }), /*#__PURE__*/_jsx(GoogleRatingsReviews, {})]
      })
    })
  });
};
export default CarleadGoogleReviews;